import { defineAction } from '~/prix'
import systemBulkGeoAction from './systemBulk.action.json' with { type: 'json' }
import { z } from 'zod'

const systemBulkGeoDefinition = defineAction({
  ...systemBulkGeoAction,

  input: z.object({
    dataset: z.string(),
    dataSourceId: z.number().nullish(),
  }),
  output: z.object({
    uploadUrl: z.string(),
    dataSourceId: z.number(),
  }),
})

export default systemBulkGeoDefinition
